// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"71e3b990","146":"7f31ca6a","318":"1e619b70","368":"4d8f694f","423":"7a585f03","453":"f8e5f10a","628":"cef7d98a","653":"23e5d6bf","667":"65461ef6","695":"0ad33f6e","707":"c85f37da","731":"e4509915","820":"6da314b6","885":"82a81986"}[chunkId] + ".chunk.js";
};